import agent from "./agent";

export function getArtikel(search, sort, skip, limit) {
  return agent.get(`articles/getListPanel`, {
    params: { filter: { search }, sort, skip: skip * limit, limit },
  });
}

export function getFilterArtikel(
  search,
  sort,
  dateStart,
  dateEnd,
  skip,
  limit,
) {
  return agent.get(`articles/getListPanel`, {
    params: {
      filter: {
        search,
        and: [
          { createdDate: { gte: dateStart } },
          { createdDate: { lte: dateEnd } },
        ],
      },
      sort,
      skip: skip * limit,
      limit,
    },
  });
}

export function getArtikelAll(search) {
  return agent.get(`articles/getListPanel`, {
    params: { filter: { search } },
  });
}

export function addArtikel(body) {
  return agent.post("articles/add", { ...body });
}

export function editArtikel(id, body) {
  return agent.put(`articles/${id}/edit`, { ...body });
}

export function deleteArtikel(id) {
  return agent.put(`articles/${id}/delete`);
}
